module.exports = __webpack_public_path__ + "static/media/local.d5afc941.svg";